export default function getCategoryLeafFromString(category: string) {
  return category.split(" > ").slice(-1)[0].trim();
}
